import ProductCard from "./ProductCard";
import { Button } from "@/components/ui/button";
import { SlidersHorizontal } from "lucide-react";

const ProductGrid = ({ products, loading, onClearAll, onOpenFilters, activeFilters, onQuickView, onEdit }) => {
  if (loading) {
    return (
      <div data-testid="products-loading" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="aspect-[4/5] bg-secondary rounded-sm" />
            <div className="h-5 bg-secondary rounded-sm w-2/3 mt-4" />
            <div className="h-3 bg-secondary rounded-sm w-1/3 mt-2" />
          </div>
        ))}
      </div>
    );
  }

  if (!products.length) {
    return (
      <div
        data-testid="products-empty"
        className="text-center py-24 border border-dashed border-border/80 rounded-sm"
      >
        <div className="font-serif text-3xl text-foreground mb-2">No matches</div>
        <p className="text-muted-foreground max-w-md mx-auto mb-6">
          Try removing a filter or browsing a different length, lace type or color.
        </p>
        <Button
          data-testid="empty-clear-btn"
          onClick={onClearAll}
          variant="outline"
          className="rounded-sm border-foreground/30 hover:bg-secondary"
        >
          Clear filters
        </Button>
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center justify-between mb-6 lg:hidden">
        <div className="text-sm text-muted-foreground">
          <span data-testid="product-count-mobile" className="font-semibold text-foreground">
            {products.length}
          </span>{" "}
          {products.length === 1 ? "piece" : "pieces"}
        </div>
        <Button
          data-testid="open-filters-mobile"
          onClick={onOpenFilters}
          variant="outline"
          size="sm"
          className="rounded-sm"
        >
          <SlidersHorizontal className="w-4 h-4 mr-2" /> Filters
          {activeFilters > 0 && (
            <span className="ml-2 inline-flex items-center justify-center min-w-5 h-5 text-[10px] rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] px-1.5">
              {activeFilters}
            </span>
          )}
        </Button>
      </div>

      <div
        data-testid="products-grid"
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-x-10 lg:gap-y-14"
      >
        {products.map((p) => (
          <ProductCard
            key={p.id}
            product={p}
            onQuickView={onQuickView}
            onEdit={onEdit}
          />
        ))}
      </div>
    </>
  );
};

export default ProductGrid;
